// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "total-29yP0";
var _3 = "total__clear-39Agu";
export { _1 as "__esModule", _2 as "total", _3 as "total__clear" }
export default { "__esModule": _1, "total": _2, "total__clear": _3 }
